import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '北新巴蜀国际艺术课程中心学生期末作品展';
const baseUrl = 'BASHUTWO';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
    rank: 1,
  },
  children: [
    {
      path: 'News',
      component: () => import('./News.vue'),
      name: 'BASHUNews',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Start',
      component: () => import('./Start.vue'),
      name: 'BASHUStart',
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: 'BASHURules',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'BASHUList',
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'BASHUDetail',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
